/*
 * @Author: zhangsheng
 * @Date: 2023-09-15 10:59:20
 * @LastEditors: zhangsheng
 * @LastEditTime: 2025-12-31 09:28:13
 * @FilePath: \demo\src\locales\en.ts
 * @Description:
 *
 * Copyright (c) 2023 by zhangsheng , All Rights Reserved.
 */
import index from './en-US/index';
import testimonials from './en-US/testimonials';
import pricing from './en-US/pricing';
import contact from './en-US/contact';
import about from './en-US/about';
import features from './en-US/features';
import team from './en-US/team';

export default {
  ...index,
  ...testimonials,
  ...pricing,
  ...contact,
  ...about,
  ...features,
  ...team,

  'Button.index.749881-0': 'Download Now',
  'Button.index.749881-1': 'Find out more',
  'Button.index.749881-2': 'Get Started',
  'Button.index.749881-3': 'Get it now',

  'Menu.index.749881-0': 'About',
  'Menu.index.749881-1': 'Testimonials',
  'Menu.index.749881-2': 'Features',
  'Menu.index.749881-3': 'Team',
  'Menu.index.749881-4': 'Pricing',
  'Menu.index.749881-5': 'Contact',

  'Contact.index.228792-0': 'Contact Us'
};
